export const Bio = {
  name: "Joshua Mhar Alcubilla",
  roles: [
    "IT Support",
    "Technical Support Specialist",
    "Service Desk Analyst",
    "Junior Web Developer",
  ],
  description:
    "Detail-oriented aspiring IT Support Specialist professional with 1 year and 5 months of experience in L1 support, incident management, and technical troubleshooting. Proven ability to resolve high-volume tickets, manage Active Directory environments, and diagnose VPN/network issues using Cisco and Palo Alto technologies. Skilled in JIRA ticketing systems and SLA compliance, with a focus on improving end-user productivity and minimizing downtime.",
  github: "https://github.com/mhardev",
  resume:
    "https://drive.google.com/file/d/1_41eLAJWop1UsjBcc6hWoX61KLehRbef/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/joshua-mhar-alcubilla-3506332b1/",
  twitter: "https://twitter.com/rielalou01",
  facebook: "https://www.facebook.com/AkiraSeika1/",
};

export const skills = [
  {
    title: "Programming",
    skills: [
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original.svg",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "PHP",
        image: 
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/php/php-original.svg",
      },
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
    ],
  },
  {
    title: "Database",
    skills: [
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mmongodb-original-wordmark.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "SQLite",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/sqlite/sqlite-original-wordmark.svg",
      },
    ],
  },
  {
    title: "Frameworks & Libraries",
    skills: [
      {
        name: "Laravel",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/b/bf/Laravel-four-icon.png",
      },
      {
        name: "React JS",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Node JS",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Livewire",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/livewire/livewire-original-wordmark.svg"
      },
      {
        name: "Vue JS",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/vuejs/vuejs-original.svg",
      },
      {
        name: "Next JS",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nextjs/nextjs-original-wordmark.svg",
      },
      {
        name: "Bootstrap",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/bootstrap/bootstrap-original-wordmark.svg",
      },
      {
        name: "TailwindCSS",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/tailwindcss/tailwindcss-original-wordmark.svg",
      },
      {
        name: "Shadcn UI",
        image:
          "https://avatars.githubusercontent.com/u/139895814?s=200&v=4",
      },
      {
        name: "Material UI",
        image: 
          "data:image/png;base64,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",
      },
      {
        name: "Devicon",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/devicon/devicon-original.svg",
      },
      {
        name: "npm",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/npm/npm-original-wordmark.svg",
      },
      {
        name: "AJAX",
        image: "https://upload.wikimedia.org/wikipedia/commons/a/a1/AJAX_logo_by_gengns.svg",

      },
      {
        name: "jQuery",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/jquery/jquery-original-wordmark.svg",
      }
    ],
  },
  {
    title: "IT Support and Operations",
    skills: [
      {
        name: "Troubleshooting ",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/8/8c/Bullet_%28typography%29.svg",
      },
      {
        name: "Incident Management",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/8/8c/Bullet_%28typography%29.svg",
      },
      {
        name: "Ticketing",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/8/8c/Bullet_%28typography%29.svg",
      },
      {
        name: "SLA Compliance",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/8/8c/Bullet_%28typography%29.svg",
      },
    ],
  },
  {
    title: "Networking",
    skills: [
      {
        name: "VPN",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/8/8c/Bullet_%28typography%29.svg",
      },
      {
        name: "DHCP",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/8/8c/Bullet_%28typography%29.svg",
      },
      {
        name: "TCP/IP",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/8/8c/Bullet_%28typography%29.svg",
      },
      {
        name: "Network Diagnostics",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/8/8c/Bullet_%28typography%29.svg",
      },
      {
        name: "Wireshark",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/8/8c/Bullet_%28typography%29.svg",
      },
      {
        name: "Patch Panel and Switch Port Tracing",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/8/8c/Bullet_%28typography%29.svg",
      },
    ],
  },
  {
    title: "Systems and Administration",
    skills: [
      {
        name: "Active Directory",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/8/8c/Bullet_%28typography%29.svg",
      },
      {
        name: "Windows",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/8/8c/Bullet_%28typography%29.svg",
      },
      {
        name: "Linux/Unix",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/8/8c/Bullet_%28typography%29.svg",
      },
    ],
  },
  {
    title: "Tools and Platforms",
    skills: [
      {
        name: "Git",
        image:
          "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "XAMPP",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/d/dc/XAMPP_Logo.png",
      },
      {
        name: "Jira",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/jira/jira-original-wordmark.svg",
      },
      {
        name: "Windows",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/windows11/windows11-original-wordmark.svg",
      },
      {
        name: "Ubuntu",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/ubuntu/ubuntu-original-wordmark.svg",
      },
      {
        name: "TrueNAS",
        image:
          "https://www.truenas.com/wp-content/uploads/2026/02/truenas-community-edition-logo-full-color-rgb-900px-w-72ppi-1.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "Wireshark",
        image: "https://upload.wikimedia.org/wikipedia/commons/d/df/Wireshark_icon.svg",
      },
      {
        name: "ManageEngine",
        image: "https://www.manageengine.com/images/logo/manageengine-logo.svg",
      },
      {
        name: "BigFix",
        image: "https://wp.logos-download.com/wp-content/uploads/2022/12/BigFix_Inc_Logo-700x201.png",
      }
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://raw.githubusercontent.com/mhardev/mhardev-v2/refs/heads/main/src/images/Experience/%5B24%5D7.ai_PH.jpg",
    role: "Associate IT Engineer - ITSS Ops",
    company: "[24]]7.ai Philippines",
    date: "April 2025 - Present",
    desc: "Provided L1 IT support in a fast-paced environment, resolving 30–50+ tickets weekly across hardware, software, network, and VPN issues. Managed Active Directory user accounts, configured workstations, and supported domain environments. Diagnosed connectivity problems using Cisco and Palo Alto VPN technologies, and utilized Wireshark for network traffic analysis. Collaborated with internal teams to ensure minimal downtime and efficient issue resolution.",
  },
  {
    id: 1,
    img: "https://upload.wikimedia.org/wikipedia/commons/7/7d/Commission_on_Higher_Education_%28CHEd%29.svg",
    role: "Project Technical Staff I (MIS)",
    company: "Commission on Higher Education - National Capital Region (CHED-NCR)",
    date: "May 2024 - December 2024",
    desc: "Delivered technical support for hardware, software, and network-related concerns within the MIS unit. Performed OS installations, system reformatting, and data backups to maintain system reliability. Troubleshot printers, routers, and connectivity issues, while assisting in IT asset inventory and workstation deployment to support daily operations. As well as Develops, tests, & implements Information Systems and Inventory Management Systems",
  },
  {
    id: 2,
    img: "https://upload.wikimedia.org/wikipedia/commons/7/7d/Commission_on_Higher_Education_%28CHEd%29.svg",
    role: "OJT Trainee (MIS)",
    company: "Commission on Higher Education - National Capital Region (CHED-NCR)",
    date: "Feb 2024 - May 2024",
    desc: "Assisted in resolving basic IT and network issues, supporting day-to-day operations of the MIS team. Maintained IT asset inventory and performed data validation using Excel and Google Sheets, ensuring accuracy and organization of records. (IT Practicum)",
  },
];

export const education = [
  {
    id: 0,
    img: "https://www.sti.edu/images/stilogo-push.png",
    school: "STI College Novaliches",
    date: "Sep 2020 - Jul 2024",
    desc: "College graduated at STI College Novaliches with degree of Bachelor of Science in Information Technology.",
    degree: "Bachelor of Science in Information Technology (BSIT)",
  },
  {
    id: 1,
    img: "https://www.sti.edu/images/stilogo-push.png",
    school: "STI College Novaliches",
    date: "Jun 2018 - Apr 2020",
    desc: "Senior High School graduated at STI College Novaliches with course of IT-MAWD, where I study IT subjects.",
    degree: "IT - Mobile Application and Web Development (IT-MAWD).",
  },
  {
    id: 2,
    img: "https://raw.githubusercontent.com/mhardev/mhardev-v2/main/src/images/Education/sta-lucia-hs.jpg",
    school: "Sta. Lucia High School",
    date: "Jun 2014 - Apr 2018",
    desc: "Junior High School graduated at Sta. Lucia High School.",
  },
  {
    id: 3,
    img: "https://graph.facebook.com/1424391204259876/picture?type=square",
    school: "Rosa L. Susano Novaliches Elementary School",
    date: "Jun 2008 - Mar 2014",
    desc: "Elementary graduated at Rosa L. Susano Novaliches Elementary School.",
  },
];

export const projects = [
  {
    id: 0,
    title: "Responsive Video",
    date: "Mar 2023",
    description:
      "A website for our 04 lab 2 session in Web Systems and Technology.",
    image:
      "https://raw.githubusercontent.com/mhardev/mhardev-v2/main/src/images/Projects/WebSystems/responsive-video.png",
    tags: [
      "HTML",
      "CSS",
    ],
    category: "website",
    webapp: "https://mhardev.github.io/Responsive-Video/",
  },
  {
    id: 1,
    title: "MOTO-JEN (Admin-Side)",
    date: "Feb 2023 - Jan 2024",
    description:
      "A web-based system with an online system with admin credentials and modules for monitoring orders and appointment with cost estimation.",
    image:
      "https://raw.githubusercontent.com/mhardev/mhardev-v2/main/src/images/Projects/MOTO-JEN/moto-jen-admin.png",
    tags: [
      "HTML",
      "CSS",
      "JavaScript",
      "JQuery",
      "AJAX",
      "PHP",
      "MySQL",
    ],
    category: "website",
    webapp: "https://www.moto-jen.online/",
  },
  {
    id: 2,
    title: "MOTO-JEN (User-Side)",
    date: "Feb 2023 - Jan 2024",
    description:
      "A web-based system with an online system with user credentials and modules for ordering and appointment with cost estimation.",
    image:
      "https://raw.githubusercontent.com/mhardev/mhardev-v2/main/src/images/Projects/MOTO-JEN/moto-jen-home.png",
    tags: [
      "HTML",
      "CSS",
      "JavaScript",
      "JQuery",
      "AJAX",
      "PHP",
      "MySQL",
    ],
    category: "website",
    webapp: "https://mobile.moto-jen.online/",
  },
  {
    id: 3,
    title: "MOTO-JEN App",
    date: "Feb 2023 - Jan 2024",
    description:
      "An android-based system with an online system with user credentials and modules for ordering and appointment with cost estimation.",
    image:
      "https://raw.githubusercontent.com/mhardev/mhardev-v2/main/src/images/Projects/MOTO-JEN/moto-jen-app.jpg",
    tags: [
      "Android Studio",
      "XML",
      "Java",
    ],
    category: "android app",
    webapp: "https://github.com/mhardev/mhardev-v2/raw/main/src/apk/app-release.apk",
  },
  {
    id: 4,
    title: "Portfolio 1.0",
    date: "Jan 2024",
    description:
      "My personal web portfolio without using Framework.",
    image:
      "https://raw.githubusercontent.com/mhardev/mhardev-v2/main/src/images/Projects/Portfolio-1.0/portfolio-1.0.png",
    tags: [
      "HTML",
      "CSS",
      "JavaScript",
      "Email JS",
    ],
    category: "website",
    webapp: "https://mhardev-old.vercel.app/",
  },
  {
    id: 5,
    title: "Weather API (Mini project)",
    date: "May 2024",
    description:
      "A mini project online weather with Weather API.",
    image:
      "https://raw.githubusercontent.com/mhardev/mhardev-v2/main/src/images/Projects/WeatherAPI/weather-app.png",
    tags: [
      "HTML",
      "CSS",
      "JavaScript",
      "OpenWeather API",
    ],
    category: "website",
    webapp: "https://mhar-weather-old.vercel.app/",
  },
  {
    id: 6,
    title: "CVMC",
    date: "Feb 2025",
    description:
      "A simple landing page project for CV Medical Clinic.",
    image:
      "https://raw.githubusercontent.com/mhardev/mhardev-v2/main/src/images/Projects/CVMC/cvmc.png",
    tags: [
      "Tailwind CSS",
      "Vue JS",
      "Email JS",
    ],
    category: [
      "website",
      "web app",
    ],
    webapp: "https://cvmc.vercel.app/",
  },
  {
    id: 7,
    title: "Weather Website with MeteoSource API",
    date: "Jul 2025",
    description:
      "An online weather website using Vue and MeteoSource API.",
    image:
      "https://raw.githubusercontent.com/mhardev/mhardev-v2/main/src/images/Projects/MeteoSourceAPI/mhardev-weather-app.png",
    tags: [
      "TailwindCSS",
      "Shadcn UI",
      "React JS",
      "MeteoSource API",
    ],
    category: [
      "website",
      "web app",
    ],
    webapp: "https://mhardev-weather-app.vercel.app/",
  },
  {
    id: 8,
    title: "Elite Barber Shop",
    date: "Feb 2026",
    description:
      "A responsive landing page for Elite Barbershop.",
    image:
      "https://raw.githubusercontent.com/mhardev/mhardev-v2/main/src/images/Projects/Elite-BarberShop/elite-barbershop.png",
    tags: [
      "Tailwind CSS",
      "Shadcn UI",
      "ReactJS",
      "Next JS",
      "Email JS",
    ],
    category: [
      "website",
      "web app",
    ],
    webapp: "https://elite-barbershop.vercel.app/",
  },
];

export const certificates = [
  {
    id: 0,
    title: "Database Foundations",
    date: "June 2022",
    description:
      "Course Completion Database Foundations at STI College Novaliches.",
    given: [
      "Oracle",
    ],
    image:
      "https://raw.githubusercontent.com/mhardev/mhardev-v2/main/src/images/Certificates/2022/databasefoundation.jpg",
    year: "2022",
    link: "https://raw.githubusercontent.com/mhardev/mhardev-v2/main/src/images/Certificates/2022/databasefoundation.jpg",
  },
  {
    id: 1,
    title: "Network Foundations",
    date: "June 2022",
    description:
      "Course Completion Network Foundations at STI College Novaliches.",
    given: [
      "Huawei",
    ],
    image:
      "https://raw.githubusercontent.com/mhardev/mhardev-v2/main/src/images/Certificates/2022/networkfoundation-thumbnail.jpg",
    year: "2022",
    link: "https://raw.githubusercontent.com/mhardev/mhardev-v2/main/src/images/Certificates/2022/networkfoundation.jpg",
  },
  {
    id: 3,
    title: "Cloud Basics- Development and Basic Concepts",
    date: "January 2024",
    description:
      "Course Certification Cloud Basics-Development and Basic Concepts at Huawei and STI College Novaliches.",
    given: [
      "Huawei",
    ],
    image:
      "https://raw.githubusercontent.com/mhardev/mhardev-v2/refs/heads/main/src/images/Certificates/2024/combasics.png",
    year: "2024",
    link: "https://raw.githubusercontent.com/mhardev/mhardev-v2/refs/heads/main/src/images/Certificates/2024/combasics.png",
  },
  {
    id: 4,
    title: "HCIA-Cloud Service V3 Course",
    date: "January 2024",
    description:
      "Course Certification HCIA-Cloud Service V3 Course at Huawei and STI College Novaliches.",
    given: [
      "Huawei",
    ],
    image:
      "https://raw.githubusercontent.com/mhardev/mhardev-v2/refs/heads/main/src/images/Certificates/2024/hcia.png",
    year: "2024",
    link: "https://raw.githubusercontent.com/mhardev/mhardev-v2/refs/heads/main/src/images/Certificates/2024/hcia.png",
  },
  {
    id: 5,
    title: "Computer Hardware Basics",
    date: "February 29, 2024",
    description:
      "Course Completion Computer Hardware Basics at CISCO Networking Academy.",
    given: [
      "Cisco Networking Academy",
    ],
    image:
      "https://raw.githubusercontent.com/mhardev/mhardev-v2/main/src/images/Certificates/2024/computerhardwarebasics.jpg",
    year: "2024",
    link: "https://raw.githubusercontent.com/mhardev/mhardev-v2/main/src/images/Certificates/2024/computerhardwarebasics.jpg",
  },
];
